import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Flags } from "./models/flags";

interface FlagsState {
  flags: Flags | null;
}

export const flagsSlice = createSlice({
  name: "auth",
  initialState: {
    flags: null,
  } as FlagsState,
  reducers: {
    setFlags: (
      state,
      action: PayloadAction<{
        flags: Flags;
      }>,
    ) => {
      state.flags = action.payload.flags;
    },
  },
});

export const { setFlags } = flagsSlice.actions;

export default flagsSlice.reducer;
